class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", async (event) => {
      // Added by MLVeda.
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      const addonid = this.getAttribute("addonid");
      const currentId = this.getAttribute("data-quantity-variant-id");
      console.log(this);
      console.log("addon: ", addonid);
      // console.log(typeof this.dataset.index);

      await cartItems.updateQuantity(this.dataset.index, 0);
      if (
        addonid != currentId &&
        document.querySelector(
          `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
        ) != null
      ) {
        const addonidex = document.querySelector(
          `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
        ).dataset.index;
        console.log(
          document.querySelector(
            `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
          )
        );
        await cartItems.updateQuantity(addonidex, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // Added By MLVeda
  async onChange(event) {
    event.preventDefault();
    var allAddOn = document.querySelectorAll(
      `input[addonid][data-quantity-variant-id]`
    );

    var operation = document.activeElement.getAttribute("name");

    await this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );

    if (event.target.hasAttribute("addonid")) {
      var addonid = event.target.attributes.addonid.nodeValue;
      if (
        event.target.attributes["data-quantity-variant-id"].nodeValue !=
        event.target.attributes.addonid.nodeValue
      ) {
        document
          .querySelector(
            `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
          )
          .setAttribute("max", event.target.value);
        console.log("event.target.value: ",event.target.value)
        console.log("event", document.activeElement.getAttribute("name"));

        if (operation == "minus") {
          var targetInput = document.querySelector(
            `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
          );
          if (targetInput.value > event.target.value) {
            console.log("good", targetInput);
            console.log(targetInput.value, event.target.value);
            targetInput.value = event.target.value;
            console.log("Max: ",targetInput.getAttribute("max"));
            await this.updateQuantity(
              document.querySelector(
                `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
              ).dataset.index,
              event.target.value,
              document.activeElement.getAttribute("name"),
              addonid
            );
          } else {
            // targetInput.value = event.target.value;
            document
              .querySelector(
                `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
              )
              .setAttribute("max", event.target.value);
          }
        }
      } else {
        document
          .querySelector(
            `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
          )
          .setAttribute("max", event.target.attributes.max.nodeValue);
      }
    } else {
      event.preventDefault();
      for (let addOn of allAddOn) {
        if (
          addOn.getAttribute("addonid") !=
          addOn.getAttribute("data-quantity-variant-id")
        ) {
          var addonid = addOn.getAttribute("addonid");
          var targetInput = document.querySelector(
            `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
          );
          targetInput.setAttribute("max", addOn.value);
          console.log("max: ", targetInput.getAttribute("data-cart-quantity"));
        }
      }
    }

    this.checkCartItems();
  }

  checkCartItems() {
    // console.log("called");
    const mainProducts = document.querySelectorAll(
      "input[addonid][data-quantity-variant-id]"
    );

    for (const element of mainProducts) {
      const addonid = element.getAttribute("addonid");

      if (
        addonid !== "" &&
        addonid !== element.getAttribute("data-quantity-variant-id")
      ) {
        const linked_item = document.querySelector(
          `input[addonid="${addonid}"][data-quantity-variant-id="${addonid}"]`
        );
        if (linked_item) {
          let total =0;
           document.querySelectorAll(`input[addonid="${addonid}"]`).forEach((item)=>{
        total = total +Number( item.value);
      })
      console.log("Total: ",total);
          linked_item.max =  Number(total) - Number(linked_item.value) ;
        }

        if (linked_item.max <= linked_item.value) {
          if (linked_item.classList.contains("disabled")) {
            console.log("disabled is in.");
          } else {
            document
              .querySelector(`button[name="plus"][newid="${addonid}"`)
              .classList.add("disabled");
          }
        } else {
          document
            .querySelector(`button[name="plus"][newid="${addonid}"`)
            .classList.remove("disabled");
        }
      }
    }
  }

  // Added By MLVeda: END
  

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
    this.checkCartItems();
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });

    this.checkCartItems();
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
